import { render, staticRenderFns } from "./contactItem.vue?vue&type=template&id=03ffb847&scoped=true&"
import script from "./contactItem.vue?vue&type=script&lang=js&"
export * from "./contactItem.vue?vue&type=script&lang=js&"
import style0 from "./contactItem.vue?vue&type=style&index=0&id=03ffb847&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ffb847",
  null
  
)

export default component.exports